<template>
  <div class="print">

    <section class="section-approval">
      <table class="mt-auto">
        <colgroup>
          <col width="180" />
          <col width="190" />
          <col />
          <col width="115" />
          <col width="115" />
          <col width="115" />
          <col width="115" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray">{{ $t("회사명") }}</th>
          <td rowspan="2">{{ form.stdInfo.field_name }}</td>
          <td rowspan="6">
            <span class="print-title">{{ `(${header.year}${$t('년')}${header.month}${$t('월')})` }}<span style="color: #0029ff"> {{ $t('MSDS 리스트 관리') }}</span></span>
          </td>
          <th rowspan="2" colspan="4" class="gray">{{ $t("결재란") }}</th>
        </tr>
        <tr/>
        <tr>
          <th rowspan="2" class="gray">{{ $t("작성자") }}</th>
          <td rowspan="2">{{ form.stdInfo.writer_name }}</td>
          <td class="gray">{{ $t('작성자') }}</td>
          <td class="gray">{{ $t('검토자') }}</td>
          <td class="gray">{{ $t('회람자') }}</td>
          <td class="gray">{{ $t('승인자') }}</td>
        </tr>
        <tr>
          <td rowspan="3">
            <div>
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td rowspan="3">
            <div>
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td rowspan="3">
            <div>
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="w-full h-full object-contain" />
            </div>
          </td>
          <td rowspan="3">
            <div>
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="w-full h-full object-contain" />
            </div>
          </td>
        </tr>
        <tr>
          <th rowspan="2" class="gray">{{ $t("작성일") }}</th>
          <td rowspan="2">{{ form.stdInfo.date }}</td>
        </tr>
      </table>

      <table class="mt-6 msds-table">
        <colgroup>
          <col width="60" />
          <col width="130" />
          <col width="130" />
          <col />
          <col width="80" />
          <col width="130" />
          <col />
          <col width="80" />
          <col width="70" />
          <col width="70" />
          <col width="70" />
          <col width="70" />
          <col width="70" />
          <col width="160" />
        </colgroup>
        <tr>
          <th class="gray" rowspan="2">{{ $t("No") }}</th>
          <th class="gray" rowspan="2">{{ $t("소속") }}</th>
          <th class="gray" rowspan="2">{{ $t("작업공정") }}<br />({{ $t("담당명") }})</th>
          <th class="gray" rowspan="2">{{ $t("물질명") }}<br />({{ $t("제품명") }})</th>
          <th class="gray" rowspan="2">{{ $t("월 사용량") }}</th>
          <th class="header-color" colspan="3">{{ $t("구성성분 및 함유량") }}</th>
          <th class="header-color" rowspan="2">{{ $t("측정대상") }}</th>
          <th class="header-color" rowspan="2">{{ $t("측정주기") }}</th>
          <th class="header-color" rowspan="2">{{ $t("특검대상") }}</th>
          <th class="header-color" rowspan="2">{{ $t("특검주기") }}</th>
          <th class="header-color" rowspan="2">{{ $t("특별관리물질") }}</th>
          <th class="gray" rowspan="2">{{ $t("비고") }}</th>
        </tr>
        <tr>
          <th class="header-color">{{ $t("CAS번호") }}</th>
          <th class="header-color">{{ $t("구성성분") }}</th>
          <th class="header-color">{{ $t("함유량") }}<br />(%)</th>
        </tr>
        <tr v-for="(item, i) in form.msds" :key="`msds_${i}`">
          <td>{{ i + 1 }}</td>
          <td>{{ item.소속 }}</td>
          <td>{{ item.작업공정 }}</td>
          <td>{{ item.물질명 }}</td>
          <td>{{ item.월사용량 }}</td>
          <td>{{ item.CAS번호 }}</td>
          <td>{{ item.구성성분 }}</td>
          <td>{{ item.함유량 }}</td>
          <td>
            <PrintCheckbox :value="item.측정대상" class="flex justify-center"/>
          </td>
          <td>{{ item.측정주기 }}{{ item.측정주기? $t("개월"): '' }}</td>
          <td>
            <PrintCheckbox :value="item.특검대상" class="flex justify-center"/>
          </td>
          <td>{{ item.특검주기 }}{{ item.특검주기? $t("개월"): '' }}</td>
          <td>
            <PrintCheckbox :value="item.특별관리물질" class="flex justify-center"/>
          </td>
          <td>{{ item.비고 }}</td>
        </tr>
      </table>
    </section>

  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: {PrintCheckbox},

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
    header: Object,
  },
  computed: {
    processedDisasterType() {
      const disasterType = this.form.stdInfo.재해형태;
      if (!disasterType) return '';

      if (disasterType.includes('직접입력_')) {
        return disasterType.replace('직접입력_', '');
      }

      return this.$t(disasterType);
    },
    gridStyle() {
      const isKorean = this.$i18n.locale === 'ko';
      return {
        'grid-template-columns': isKorean ? '1fr 1fr 1fr 1fr' : '1fr 1fr',
        'gap': '1rem'
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.print {
  .header-color {
    background-color: #EEEDFA;
  }

  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      word-break: break-word;
      white-space: normal;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 12px;
      font-size: 15px;
      white-space: normal;
    }
    td {
      word-break: keep-all;
      padding: 5px;
      font-size: 14px;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  .msds-table {
    th, td {
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-all;
      hyphens: auto;
      line-height: 1.3;
      height: auto;
      min-height: 40px;
      vertical-align: middle;

      br {
        display: block;
        content: "";
        margin: 4px 0;
      }
    }

    th {
      font-size: 14px;
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left
    }
  }

  .section-file {
    th { width: 234px; }
  }

  .section-photo {
    td { padding: 1rem; }
  }
}


@media print {
  .page-break { page-break-inside:avoid; page-break-after:auto }
}
</style>
